module.exports = __webpack_public_path__ + "img/bg.9924abe1.png";